import React from 'react';
import dayjs from 'dayjs';
import { LocalTimeLocalTimeTuple } from '../../../../../../../integrated-client/models';
import { IDateInputsRowProps as ITimeInputsRowProps } from '../DateInputsRow/DateInputsRow';
import DateTimeInputsRowData from '../DateTimeInputsRowData/DateTimeInputsRowData';
import TimeInputs from './TimeInputs/TimeInputs';
import CursiveSpan from '../../../../../../../components/CursiveSpan/CursiveSpan';
import { ANY } from '../../../../../../../utils/Constants';
import { sortDateTime, DateOrTimeObj } from '../../../../../../../utils/MiscUtils';

export const RESTRICTIONS_TABLE_TIME_FORMAT = 'HH:mm';

export type TimeClickHandler = (startTime: DateOrTimeObj, endTime: DateOrTimeObj) => void;

export const TimeInputsRow: React.FC<ITimeInputsRowProps> = (props) => {
  const { rowData, rowIndex, isLastRow = false, isSorting, updateRow } = props;

  if (!rowData) {
    return null;
  }

  const { timeRanges } = rowData;

  const addTimeRow: TimeClickHandler = (startTime, endTime) => {
    const newTimeRow = { item1: startTime, item2: endTime };
    const newTimeRanges = timeRanges ? [...timeRanges, newTimeRow] : [newTimeRow];
    handleRowDataChange({ timeRanges: newTimeRanges.sort(sortDateTime) });
  };

  const removeTimeRow = (rowIndex: number) => {
    const newTimeRanges = timeRanges ? [...timeRanges] : [];
    newTimeRanges.splice(rowIndex, 1);
    handleRowDataChange({ timeRanges: newTimeRanges.sort(sortDateTime) });
  };

  const handleRowDataChange = (data: any) => updateRow({ rowData: { ...rowData, ...data }, rowIndex });

  return (
    <>
      {timeRanges && timeRanges.length ? (
        <>
          {timeRanges?.map((tr: LocalTimeLocalTimeTuple, i: number) => (
            <DateTimeInputsRowData
              key={`tr_${tr.item1}${tr.item2}${Math.random()}`}
              rowIndex={i}
              from={dayjs(tr.item1?.toString(), RESTRICTIONS_TABLE_TIME_FORMAT).format(RESTRICTIONS_TABLE_TIME_FORMAT)}
              to={dayjs(tr.item2?.toString(), RESTRICTIONS_TABLE_TIME_FORMAT).format(RESTRICTIONS_TABLE_TIME_FORMAT)}
              removeRowHandler={removeTimeRow}
            />
          ))}
          <TimeInputs clickHandler={addTimeRow} isSorting={isSorting} />
        </>
      ) : (
        <>
          <CursiveSpan>{ANY}</CursiveSpan>
          {!isLastRow && <TimeInputs clickHandler={addTimeRow} isSorting={isSorting} />}
        </>
      )}
    </>
  );
};

export default TimeInputsRow;
